import { render, staticRenderFns } from "./StoreEmpty.vue?vue&type=template&id=32a2cb25"
import script from "./StoreEmpty.vue?vue&type=script&lang=js"
export * from "./StoreEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports